import { Save, Share2, Instagram, Facebook, AtSign, Music2 } from "lucide-react";

const NETWORKS = [
  { key: "instagram", label: "Instagram", icon: Instagram, placeholder: "https://instagram.com/tunegocio" },
  { key: "facebook", label: "Facebook", icon: Facebook, placeholder: "https://facebook.com/tunegocio" },
  { key: "twitter", label: "X", icon: AtSign, placeholder: "https://x.com/tunegocio" },
  { key: "tiktok", label: "TikTok", icon: Music2, placeholder: "https://www.tiktok.com/@tunegocio" },
];

/** Redes sociales: cuatro links que salen como botones en la página de agenda. */
export default function SocialTab({ brandSettings, updateBrandSettings, handleSaveBrand }) {
  const links = brandSettings.links || {};
  const setLink = (key, value) => updateBrandSettings({ ...brandSettings, links: { ...links, [key]: value } });
  const filled = NETWORKS.filter((n) => (links[n.key] || "").trim()).length;

  return (
    <section className="cp-social">
      <header className="cp-page-head">
        <div>
          <h2 className="cp-page-title" data-tour="social.links">Redes sociales {filled > 0 && <span className="cp-count">{filled} de {NETWORKS.length}</span>}</h2>
          <p className="cp-page-sub">Se muestran como botones en tu página de agenda. Deja vacías las que no uses.</p>
        </div>
      </header>
      <article className="cp-card">
        <div className="cp-form">
          {NETWORKS.map(({ key, label, icon: Icon, placeholder }) => (
            <label key={key} className="cp-field">
              <span><Icon size={14} style={{ verticalAlign: -2, marginRight: 4 }} /> {label}</span>
              <input type="url" className="cp-input" inputMode="url" autoCapitalize="none" placeholder={placeholder} value={links[key] ?? ""} onChange={(e) => setLink(key, e.target.value)} />
            </label>
          ))}
          <button type="button" className="cp-btn cp-btn-primary" style={{ justifySelf: "start" }} onClick={handleSaveBrand}><Save size={16} /> Guardar</button>
        </div>
      </article>
      <p className="cp-hint" style={{ marginTop: "0.75rem" }}><Share2 size={13} style={{ verticalAlign: -2 }} /> Tu link de WhatsApp sale solo, con el número que conectaste.</p>
    </section>
  );
}
